import * as React from "react";
import Modal, { ModalSize } from "../../misc/components/modal";
import { SessionTypeSelection } from "./SessionTypeSelection";
import { VisitSelection } from "./VisitSelection";
import { startSessionWizardReducer, initialState, SetSessionAction, SetSessionTypeAction, SetSessionCandidatesAction, SubjectLocationAction, SetFutureVisitItemsAction, SetCurrentVisitItemsAction, SetOustandingVisitsAction, SetSkippingAnnotationAction, StartSessionWizardReducerState, SetSelectedDeviceAction, SetSelectedDeviceTypeAction, SetVitaloJak1DeviceSerialAction, SetVitaloJak1MediaSerialAction, StartSessionWizardActions, SetVitaloJak1IsNotConfiguredAction, RaiseConfigurationWarningAction, SetRollingVisitItemsAction, RemoteDeviceSelectAction } from "./StartSessionWizardReducer";
import { Routes, Route, MemoryRouter, useNavigate, HashRouter } from "react-router-dom";
import DocumentTitle from "../../misc/components/DocumentTitle";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { PairDeviceLinkV2 } from "./PairDeviceLinkV2";
import { DeviceSelection } from "./DeviceSelection";
import { ApiDevices, Device } from "../../misc/api/DeviceLinkApi/Devices";
import * as GenericMessages from '../../misc/api/DeviceLinkApi/GenericMessages';
import { DeviceTypes, QueryCondition, SessionScheduleItem, SubjectTypes } from "../../misc/api/apiTypes";
import { SkippingVisit } from "./SkippingVisit";
import { VitaloJak1CheckExistingData } from "./VitaloJak1/VitaloJak1CheckExistingData";
import { VitaloJak2CheckExistingData } from "./VitaloJak2/VitaloJak2CheckExistingData";
import { StatStripXpress2CheckExistingData } from "./StatStripXpress2/StatStripXpress2CheckExistingData";
import { useSecurityContext } from "../../Core/SecurityContext";
import { DeviceSerial } from "./VitaloJak1/DeviceSerial";
import { PositionSteps } from "./VitaloJak1/PositionSteps";
import { ConfigureSteps } from "./VitaloJak1/ConfigureSteps";
import { PreparationSteps } from "./VitaloJak1/PreparationSteps";
import { AttachSensorSteps } from "./VitaloJak1/AttachSensorSteps";
import { VitaloJak1ConnectionSteps } from "./VitaloJak1/ConnectionSteps";
import { CardSerial } from "./VitaloJak1/CardSerial";
import { VitaloJak2ConnectionSteps } from "./VitaloJak2/ConnectionSteps";
import { VitaloJak2AttachSensorSteps } from "./VitaloJak2/AttachSensorSteps";
import { VitaloJak2ConfigureSteps } from "./VitaloJak2/ConfigureSteps";
import { VitaloJak2Configure } from "./VitaloJak2/VitaloJak2Configure";
import { VitaloJak2PositionSteps } from "./VitaloJak2/PositionSteps";
import { StatStripXpress2ConnectionSteps } from "./StatStripXpress2/StatStripXpress2ConnectionSteps";
import { StatStripXpress2Configure } from "./StatStripXpress2/StatStripXpress2Configure";
import { StatStripXpress2UsageSteps } from "./StatStripXpress2/StatStripXpress2UsageSteps";
import { Confirmation } from "./Confirmation";
import { CriticalError } from "./CriticalError";
import { WorkflowSelection } from "./P230In2itiveEDiary/WorkflowSelection";
import { ConfigureP230In2itiveEDiary } from "./P230In2itiveEDiary/ConfigureP230In2itiveEDiary";
import { VitaloJak1Configure } from "./VitaloJak1/VitaloJak1Configure";
import { Success } from "./Success";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { RemotelyConfigureP230In2itiveEDiary } from "./P230In2itiveEDiary/RemotelyConfigureP230In2itiveEDiary";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { AnalysisSet, StudyScheduleSession, Subject } from "webportalclient";
import { RemoteDeviceSelect } from "./P230In2itiveEDiary/RemoteDeviceSelect";
import { useWindowSize } from "../../misc/Hooks/UseWindowSize";
import { uniqBy } from "../../misc/ArrayFunctions";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { P230HomeSpirometryRemoteConfigure } from "./P230HomeSpirometry/P230HomeSpirometryRemoteConfigure";
import { P230HomeSpirometryLocalConfigure } from "./P230HomeSpirometry/P230HomeSpirometryLocalConfigure";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { TestingAssistContextProvider } from "../../TestingAssist/TestingAssistContextProvider";
import { P230HomeSpirometryNavigate } from "./P230HomeSpirometry/P230HomeSpirometryNavigate";
import { Outlet } from "react-router-dom";

const steps = [
    "session-type",
    "visit",
    "device-selection",
    "skipping-visit",
    "pair-device-link",
    "error",
    "not-handled",
    "vj1",
    "vj1-device-serial",
    "vj1-confirmation",
    "vj1-configuring",
    "vj1-connection-steps",
    "vj1-card-serial",
    "vj1-preparation",
    "vj1-attach-sensor-steps",
    "vj1-configure-steps",
    "vj1-position-steps",
    "vj2",
    "vj2-connection-steps",
    "vj2-configure",
    "vj2-configure-steps",
    "vj2-position-steps",
    "vj2-sensor-steps",
    "vj2-confirmation",
    "p230",
    "p230-home-spirometry",
    "p230-configure",
    "p230-home-spirometry-locally-configure",
    "p230-home-spirometry-remote-device-select",
    "p230-home-spirometry-location",
    "p230-home-spirometry-remotely-configure",
    "p230-home-spirometry-navigate-to-live-testing",
    "p230-remote-device-select",
    "p230-remotely-configure",
    "p230-location",
    "p230-confirmation",
    "p230-complete",
    "blood-glucose",
    "blood-glucose-connection-steps",
    "blood-glucose-usage-steps",
    "blood-glucose-configure",
    "blood-glucose-confirmation",
    ] as const;

type WizardStep = typeof steps[number];
interface DeviceSwitchProps {
    state: StartSessionWizardReducerState;
    dispatch?: React.Dispatch<StartSessionWizardActions>;
    subject: Subject;
    wizardError?: string;
    onError: (message: string) => void;
    onComplete: (redirect?: string) => void;
    goTo: (step: WizardStep) => void;
    goBack: () => void;
    currentStep: string;
}

const getSelectedSessions = (state: StartSessionWizardReducerState): StudyScheduleSession[] => {
    let checkedSelectedItems = state.selectedSessionScheduleItem.filter(ssi => ssi.checked);

    let selectedSessions = state.outstandingVisits.map(v =>
        v.studyScheduleSessions.map(s => checkedSelectedItems.map(ssi => ssi.session).includes(s.id) ? s : null)).flat().filter(x => x !== null);

    let selectedRollingSessions = state.rollingVisitItems.map(s => checkedSelectedItems.map(ssi => ssi.session).includes(s.id) ? s : null).filter(x => x !== null);

    selectedSessions = [...selectedSessions, ...selectedRollingSessions];

    return uniqBy(selectedSessions, (a, b) => a.id === b.id);
}

const VitaloJAK1Switch = ({ currentStep, goTo, goBack, state, dispatch, subject, onError, onComplete }: DeviceSwitchProps) => {

    const [error, setError] = React.useState<string>(undefined);
    const [showError, setShowError] = React.useState<boolean>(false);
    const legacyClient = useWebPortalLegacyClient();
    const { study } = useCurrentStudyConfigurationContext();

    const handleDeviceSerialChange = (value: string) => {
        dispatch(SetVitaloJak1DeviceSerialAction.create(value));
    }

    const handleCardSerialChange = async (value: string) => {
        dispatch(SetVitaloJak1MediaSerialAction.create(value));
    }

    const onDeviceNext = (value: string, isValid?: boolean, message?: string) => {
        if (!isValid && message) {
            setShowError(true);
        } else {
            setShowError(false);
        }
        setError(message);

        if ((message === null || message === undefined)) {
            setError(undefined);
            goTo("vj1-card-serial");
        }
    }

    const onCardNext = async (value: string, isValid?: boolean, message?: string) => {
        if (!isValid && message) {
            setShowError(true);
        } else {
            setShowError(false);
        }

        setError(message);

        if ((value !== null && value !== undefined) && value !== '' && value.charAt(0) === 'F') value = value.substring(1);

        if (isValid) {
            const sessionBySerialNumber = await legacyClient.getCoughSessions([{ Member: 'MediaSerialNumber', Values: ['FF' + value] }])
            const result = await legacyClient.checkVitaloJAKCardAvailability(value, study.id);
            if (!result.Available) {
                if (sessionBySerialNumber.Data[0].StatusName !== "Not Configured") {
                    setShowError(true);
                    return setError("Card serial already in use");
                }
            }
        }

        if ((message === null || message === undefined)) {
            setShowError(false);
            setError(undefined);
            goTo("vj1-connection-steps");
        } else {
            setShowError(true);
        }
    }

    const session = getSelectedSessions(state);
    const device = { DeviceTypeName: DeviceTypes.VitaloJAK1, SerialNumber: state.vitalojak1.deviceSerial, SerialNumberPrefix: "MD", MediaSerialNumber: state.vitalojak1.mediaSerial, MediaSerialNumberPrefix: "FF" };

    return (
        <>
            {currentStep === "vj1-device-serial" && (
                <DeviceSerial
                    value={state.vitalojak1.deviceSerial}
                    showError={showError}
                    error={error}
                    onChange={handleDeviceSerialChange}
                    onNext={onDeviceNext}
                    onBack={goBack}
                />
            )}

            {currentStep === "vj1-card-serial" && (
                <CardSerial value={state.vitalojak1.mediaSerial} showError={showError} error={error} onChange={handleCardSerialChange} onNext={onCardNext} onBack={() => goBack()} />
            )}
            {currentStep === "vj1-connection-steps" && (
                <VitaloJak1ConnectionSteps onNext={() => goTo("device-selection")} onBack={() => goBack()} />
            )}
            {currentStep === "vj1-confirmation" && (
                <>
                    <div className="modal-body">
                        <Confirmation
                            intendedDeviceDetails={device}
                            subject={subject}
                            visits={state.outstandingVisits}
                            sessions={session}
                            selectedDevice={state.selectedDevice}
                            configurationWarning={state.configurationWarning}
                            isNotConfigured={state.vitalojak1.notConfigured}
                        />
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={() => goTo("vj1-configuring")}>Configure Device</button>
                    </div>
                </>
            )}
            {currentStep === "vj1-configuring" && (
                <VitaloJak1Configure
                    subject={subject}
                    device={device}
                    deviceId={state.selectedDevice ? state.selectedDevice.id : ""}
                    session={session[0]}
                    isNotConfigured={state.vitalojak1.notConfigured}
                    onError={(message) => {
                        dispatch(SetVitaloJak1IsNotConfiguredAction.create(true));
                        onError(message);
                        goTo("error")
                    }}
                    onComplete={() => goTo("vj1-preparation")}
                />
            )}
            {currentStep === "vj1-preparation" && (
                <PreparationSteps onNext={() => goTo("vj1-attach-sensor-steps")} />
            )}
            {currentStep === "vj1-attach-sensor-steps" && (
                <AttachSensorSteps onNext={() => goTo("vj1-configure-steps")} onBack={() => goBack()} />
            )}
            {currentStep === "vj1-configure-steps" && (
                <ConfigureSteps onNext={() => goTo("vj1-position-steps")} onBack={() => goBack()} />
            )}
            {currentStep === "vj1-position-steps" && (
                <PositionSteps onComplete={onComplete} onBack={() => goBack()} />
            )}
        </>
    );

}

const VitaloJAK2Switch = ({ goTo, goBack, currentStep, state, subject, onError, onComplete }: DeviceSwitchProps) => {
    const sessions = getSelectedSessions(state);

    return (
        <>
            {currentStep === "vj2-connection-steps" && (
                <VitaloJak2ConnectionSteps onBack={() => goBack()} onNext={() => goTo("device-selection")} />
            )}
            {currentStep === "vj2-confirmation" && (
                <>
                    <div className="modal-body">
                        <Confirmation
                            intendedDeviceDetails={null}
                            subject={subject}
                            visits={state.outstandingVisits}
                            sessions={sessions}
                            selectedDevice={state.selectedDevice}
                            configurationWarning={state.configurationWarning}
                            isNotConfigured={state.vitalojak1.notConfigured}
                        />
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={() => goTo("vj2-configure")}>Configure Device</button>
                        <button className="btn btn-primary btn-outline" onClick={() => goBack()}>Back</button>
                    </div>
                </>
            )}
            {currentStep === "vj2-configure" && (
                <VitaloJak2Configure
                    subject={subject}
                    device={state.selectedDevice}
                    outstandingVisits={state.outstandingVisits}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        goTo("error")
                    }}
                    onComplete={() => goTo("vj2-sensor-steps")}
                />
            )}
            {currentStep === "vj2-sensor-steps" && (
                <VitaloJak2AttachSensorSteps onNext={() => goTo("vj2-configure-steps")} />
            )}
            {currentStep === "vj2-configure-steps" && (
                <VitaloJak2ConfigureSteps onNext={() => goTo("vj2-position-steps")} onBack={() => goBack()} />
            )}
            {currentStep === "vj2-position-steps" && (
                <VitaloJak2PositionSteps onNext={onComplete} onBack={() => goBack()} />
            )}
        </>
    );
}

const BloodGlucoseSwitch = ({ currentStep, goTo, goBack, state, subject, onComplete, onError }: DeviceSwitchProps) => {

    const session = getSelectedSessions(state);

    return (
        <>
            {currentStep === "blood-glucose-connection-steps" && (
                <StatStripXpress2ConnectionSteps onNext={() => goTo("device-selection")} />
            )}
            {currentStep === "blood-glucose-confirmation" && (
                <>
                    <div className="modal-body">
                        <Confirmation
                            subject={subject}
                            visits={state.outstandingVisits}
                            sessions={session}
                            selectedDevice={state.selectedDevice}
                            configurationWarning={state.configurationWarning}
                            intendedDeviceDetails={null}
                            isNotConfigured={false}
                        />
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={() => goTo("blood-glucose-configure")}>Next</button>
                    </div>
                </>
            )}
            {currentStep === "blood-glucose-configure" && (
                <StatStripXpress2Configure
                    subjectId={subject.id}
                    selectedDevice={state.selectedDevice}
                    sessionScheduleItem={session[0]}
                    onError={(message) => {
                        onError(message);
                        goTo("error");
                    }}
                    onComplete={() => goTo("blood-glucose-usage-steps")}
                />
            )}
            {currentStep === "blood-glucose-usage-steps" && (
                <StatStripXpress2UsageSteps onComplete={onComplete} />
            )}
        </>
    );
}

const P230In2itiveSwitch = ({ currentStep, goTo, goBack, state, dispatch, subject, onComplete, onError }: DeviceSwitchProps) => {
    const sessions = getSelectedSessions(state);

    return (
        <>
            {currentStep === "p230-location" && (
                <WorkflowSelection location={state.subjectLocation}
                    onSelect={(location) => dispatch(SubjectLocationAction.create(location))}
                    onBack={() => goBack()}
                    onLocal={() => goTo("device-selection")}
                    onRemote={() => goTo("p230-remote-device-select")}
                />
            )}
            {currentStep === "p230-confirmation" && (
                <>
                    <div className="modal-body">
                        <Confirmation
                            intendedDeviceDetails={null}
                            subject={subject}
                            visits={[...state.outstandingVisits, ...state.rollingVisitItems.map(r => r.studyScheduleVisit)]}
                            sessions={sessions}
                            selectedDevice={state.selectedDevice}
                            configurationWarning={state.configurationWarning}
                            isNotConfigured={state.vitalojak1.notConfigured}
                        />
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={() => goTo("p230-configure")}>Configure Device</button>
                        <button className="btn btn-primary btn-outline" onClick={() => goBack()}>Back</button>
                    </div>
                </>
            )}
            {currentStep === "p230-configure" && (
                <ConfigureP230In2itiveEDiary
                    subject={subject}
                    sessionScheduleItems={sessions}
                    selectedDevice={state.selectedDevice}
                    onError={(message) => {
                        onError(message);
                        goTo("error")
                    }}
                    onComplete={() => goTo("p230-complete")}
                />
            )}
            {currentStep === "p230-remote-device-select" && (
                <RemoteDeviceSelect
                    subject={subject}
                    selectedDevice={state.diary.remoteDevice}
                    onSelect={(device) => dispatch(RemoteDeviceSelectAction.create(device))}
                    onError={(message) => {
                        onError(message);
                        goTo("error")
                    }}
                    onBack={() => goBack()}
                    onNext={() => goTo("p230-remotely-configure")}
                />
            )}
            {currentStep === "p230-remotely-configure" && (
                <RemotelyConfigureP230In2itiveEDiary
                    subject={subject}
                    remoteDeviceSelected={state.diary.remoteDevice}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        goTo("error");
                    }}
                    onComplete={() => goTo("p230-complete")}
                />
            )}
            {currentStep === "p230-complete" && (
                <Success message="Diary Configuration Complete" onClose={onComplete} />
            )}
        </>
    );
}

const P230HomeSpirometrySwitch = ({ currentStep, goBack, goTo, state, dispatch, subject, onComplete, onError }: DeviceSwitchProps) => {
    const [analysisSetId, setAnalysisSetId] = React.useState<string | undefined>();

    const sessions = getSelectedSessions(state);
    

    return (
        <>
            {currentStep === "p230-home-spirometry-location" && (
                <WorkflowSelection location={state.subjectLocation}
                    onSelect={(location) => dispatch(SubjectLocationAction.create(location))}
                    onBack={() => goBack()}
                    onLocal={() => goTo("device-selection")}
                    onRemote={() => goTo("p230-home-spirometry-remote-device-select")}
                />
            )}
            {currentStep === "p230-home-spirometry-remote-device-select" && (
                <RemoteDeviceSelect
                    subject={subject}
                    selectedDevice={state.diary.remoteDevice}
                    onSelect={(device) => dispatch(RemoteDeviceSelectAction.create(device))}
                    onError={(message) => {
                        onError(message);
                        goTo("error")
                    }}
                    onBack={() => goBack()}
                    onNext={() => goTo("p230-home-spirometry-remotely-configure")}
                />
            )}
            {currentStep === "p230-home-spirometry-locally-configure" && (
                <P230HomeSpirometryLocalConfigure
                    subject={subject}
                    deviceSelected={state.selectedDevice}
                    sessionScheduleItems={sessions}
                    onError={(message) => {
                        onError(message);
                        goTo("error")
                    }}
                    onNext={(set) => { setAnalysisSetId(set); goTo("p230-home-spirometry-navigate-to-live-testing") }}
                />
            )}
            {currentStep === "p230-home-spirometry-remotely-configure" && (
                <P230HomeSpirometryRemoteConfigure
                    subject={subject}
                    remoteDeviceSelected={state.diary.remoteDevice}
                    sessionScheduleItems={sessions}
                    onComplete={onComplete}
                />
            )}
            {currentStep === "p230-home-spirometry-navigate-to-live-testing" && (
                <P230HomeSpirometryNavigate
                    onComplete={onComplete}
                    analysisSetId={analysisSetId}
                />
            )}
        </>
    );
}

const NotHandled = ({ goBack }) => {

    return (
        <>
            <div className="modal-body">
                <Alert show={true} category={AlertCategoryEnum.Danger}>The selected device type cannot be used in this workflow</Alert>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={() => goBack()}>Back</button>
            </div>
        </>
    );
}

interface StartSessionWizardProps {
    subjectId: string;
    onWizardClose: (redirect?: string) => void;
}

export const StartSessionWizard = ({ subjectId, onWizardClose }: StartSessionWizardProps) => {
    const windowSize = useWindowSize(1200);

    return (
        <DocumentTitle title="Start Session | Vitalograph Web Portal">
            <Modal show={true} size={windowSize ? ModalSize.Large : ModalSize.Normal} header="Start Session">
                <StartSessionWizardCore subjectId={subjectId} onWizardClose={onWizardClose} />
            </Modal>
        </DocumentTitle>
    );
}

declare const rootUrl: string;

const StartSessionWizardCore = ({ subjectId, onWizardClose }) => {
    const [state, dispatch] = React.useReducer(startSessionWizardReducer, initialState);
    const [devicesConnected, setDevicesConnected] = React.useState<Device[]>([]);
    const [processing, setProcessing] = React.useState<boolean>(false);
    const [wizardError, setWizardError] = React.useState<string>(null);
    const [subject, setSubject] = React.useState<Subject>();
    const { currentUserPermissions } = useSecurityContext();
    const navigate = useNavigate();
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();


    const [stepIndex, setStepIndex] = React.useState(0);
    enum WizardSessionTypes {
        VitaloJAK1,
        VitaloJAK2,
        P230HomeSpirometry,
        P230,
        BloodGlucose,

    }
    const [sessionTypeContext, setSessionTypeContext] = React.useState<WizardSessionTypes | null>(null)
    const [currentStep, setCurrentStep] = React.useState<WizardStep>("session-type");
    const [history, setHistory] = React.useState<WizardStep[]>([]);

    const goTo = (step: WizardStep) => {
        if (steps.includes(step)) {
            setHistory(prev => [...prev, currentStep]);
            setCurrentStep(step);
        }
    };

    const goBack = () => {
        setHistory(prev => {
            if (prev.length === 0) return prev;
            const lastStep = prev[prev.length - 1];
            setCurrentStep(lastStep);
            return prev.slice(0, -1);
        });
    };

    React.useEffect(() => {
        const init = async () => {
            const result = await client.client.getSubject(subjectId, undefined, "site($expand=study($select=protocol))");
            setSubject(result);
        }

        init();
    }, [subjectId]);

    React.useEffect(() => {
        if (wizardError) {
            goTo("error");
        }
    }, [wizardError]);

    const onStartSession = async (skipAnnotation?: string) => {
        const onCoughSession = async (session: SessionScheduleItem) => {
            switch (session.DeviceType.Id) {
                case DeviceTypes.VitaloJAK1:
                    setSessionTypeContext(WizardSessionTypes.VitaloJAK1);
                    const coughSessions = await client.client.getCoughSessions(undefined, `visit/subjectId eq ${subjectId} and name eq '${session.Label}'`, undefined, "visit");
                    const coughSessionExists = coughSessions && coughSessions.value && coughSessions.value.length > 0;
                    if (coughSessionExists) {
                        const coughSession = coughSessions.value[0];
                        if (coughSession.serialNumber && coughSession.mediaSerialNumber) {
                            goTo("vj1-connection-steps");
                            break;
                        }
                    }
                    goTo("vj1-device-serial");
                    break;
                case DeviceTypes.VitaloJAK2:
                    setSessionTypeContext(WizardSessionTypes.VitaloJAK2);
                    goTo("vj2-connection-steps");
                    break;
                default:
                    goTo("not-handled");
            }
        }

        const selectedSessionIds = state.selectedSessionScheduleItem.filter(x => x.checked).map(i => i.session);

        // TODO: Check selected sessions
        const sessionDetails = await legacyClient.getSessionSchedule({
            Filters: [
                { Member: "Id", Values: selectedSessionIds },
            ]
        });

        const firstSession = sessionDetails.Data[0];

        if (state.currentVisitItems.filter(cvi => cvi.mandatory).length > 0 &&
            state.futureVisitItems.filter(fvi => fvi.value.map(s => s.id).includes(firstSession.Id)).length > 0
            && !skipAnnotation
        ) {
            return goTo("skipping-visit");
        }

        dispatch(SetSelectedDeviceTypeAction.create(firstSession.DeviceType.Id));

        switch (state.selectedSessionType) {
            case SessionTypes.Fvc:
                switch (firstSession.DeviceType.Id) {
                    case DeviceTypes.Pneumotrac:
                        goTo("not-handled");
                        break;
                    case DeviceTypes.Spirotrac5:
                        goTo("not-handled");
                        break;
                    case DeviceTypes.Spirotrac6:
                        goTo("not-handled");
                        break;
                    case DeviceTypes.In2itiveP230EDiary:
                        setSessionTypeContext(WizardSessionTypes.P230HomeSpirometry);
                        goTo("p230-home-spirometry-location");
                        break;
                }
                break;
            case SessionTypes.Cough:
                return await onCoughSession(firstSession);
            case SessionTypes.BloodGlucose:
                setSessionTypeContext(WizardSessionTypes.BloodGlucose)
                goTo("blood-glucose-connection-steps");
                break;
            case SessionTypes.EDiary:
                switch (firstSession.DeviceType.Id) {
                    case DeviceTypes.In2itiveP230EDiary:
                        setSessionTypeContext(WizardSessionTypes.P230);
                        goTo("p230-location");
                        break;
                    default:
                        goTo("not-handled");
                }
                break;
            default:
                goTo("not-handled");
        }
    }

    const onDeviceSelection = async () => {
        const onVitaloJAK1 = async () => {
            const result = await VitaloJak1CheckExistingData(client.client, state.selectedDevice, subject.typeKey as SubjectTypes, subject.id, getSelectedSessions(state),
                (message, isWarning, deviceSerial, cardSerial) => {
                    if (isWarning) {
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    }
                    if (deviceSerial !== undefined) {
                        dispatch(SetVitaloJak1DeviceSerialAction.create(deviceSerial));
                    }
                    if (cardSerial !== undefined) {
                        dispatch(SetVitaloJak1MediaSerialAction.create(cardSerial));
                    }
                    else
                        setWizardError(message);
                });
            if (result)
                goTo("vj1-confirmation");
        }

        const onVitaloJAK2 = async () => {
            const result = await VitaloJak2CheckExistingData(client.client, legacyClient, subject, state.selectedDevice, subject.id, getSelectedSessions(state), currentUserPermissions.find(x => x.Id === PermissionEnum.ForceVitaloJak2Reconfiguration) !== undefined,
                (message, isWarning) => {
                    if (isWarning)
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    else
                        setWizardError(message);
                });
            if (result)
                goTo("vj2-confirmation");
        }

        const onStatStripXpress2 = async () => {
            const result = await StatStripXpress2CheckExistingData(client.client, state.selectedDevice,
                (message, isWarning) => {
                    if (isWarning)
                        dispatch(RaiseConfigurationWarningAction.create(message));
                    else
                        setWizardError(message);
                });
            if (result) {
                goTo("blood-glucose-confirmation");
            }
        }

        const onP230In2itive = async () => {
            goTo("p230-confirmation");
        }

        const onP230In2itiveHomeSpirometry = async () => {
            goTo("p230-home-spirometry-locally-configure")
        }

        try {
            setProcessing(true);
            switch (state.selectedDevice.type) {
                case DeviceTypes.VitaloJAK1:
                    setSessionTypeContext(WizardSessionTypes.VitaloJAK1);
                    await onVitaloJAK1();
                    break;
                case DeviceTypes.VitaloJAK2:
                    setSessionTypeContext(WizardSessionTypes.VitaloJAK2);
                    await onVitaloJAK2();
                    break;
                case DeviceTypes.StatStripXpress2:
                    setSessionTypeContext(WizardSessionTypes.BloodGlucose);
                    await onStatStripXpress2();
                    break;
                case DeviceTypes.In2itiveP230EDiary:
                    if (state.selectedSessionType === SessionTypes.EDiary) {
                        setSessionTypeContext(WizardSessionTypes.P230);
                        await onP230In2itive();
                    }
                    else {
                        setSessionTypeContext(WizardSessionTypes.P230HomeSpirometry);
                        await onP230In2itiveHomeSpirometry();
                        break;
                    }
            }
        }
        catch (err) {
            return setWizardError(GenericMessages.FailedConfigureDeviceMessage);
        } finally {
            setProcessing(false);
        }

    }

    const onDataError = async (message: string, isWarning: boolean) => {
        if (isWarning)
            dispatch(RaiseConfigurationWarningAction.create(message));
        else
            setWizardError(message);
    }

    const onDevicesConnected = async (devices: Device[]) => {
        setDevicesConnected(devices);
    }

    return (
        <ErrorBoundary>
            {currentStep === "session-type" && (
                <SessionTypeSelection
                    selectedItem={state.selectedSessionType}
                    onSelect={(id, multiSelect) => dispatch(SetSessionTypeAction.create(id, multiSelect))}
                    onWizardClose={onWizardClose}
                    goTo={goTo}
                />
            )}
            {currentStep === "visit" && (
                <VisitSelection
                    selectedItems={state.selectedSessionScheduleItem.filter(s => s.checked).map(s => s.session)}
                    subject={subject}
                    sessionType={state.selectedSessionType}
                    currentVisitItems={state.currentVisitItems}
                    futureVisitItems={state.futureVisitItems}
                    rollingVisitItems={state.rollingVisitItems}
                    onSelect={(id, checked) => dispatch(SetSessionAction.create(id, checked))}
                    onSettingOutstandingVisits={(i) => dispatch(SetOustandingVisitsAction.create(i))}
                    onSettingCurrentVisitItems={(i) => dispatch(SetCurrentVisitItemsAction.create(i))}
                    onSettingFutureVisitItems={(i) => dispatch(SetFutureVisitItemsAction.create(i))}
                    onSettingRollingVisitItems={(i) => dispatch(SetRollingVisitItemsAction.create(i))}
                    onSettingCandidates={(c) => dispatch(SetSessionCandidatesAction.create(c))}
                    onStartSession={onStartSession}
                    goTo={goTo}
                    goBack={goBack}
                />
            )}
            {currentStep === "device-selection" && (
                <DeviceSelection
                    submitting={processing}
                    subject={subject}
                    selectedDeviceType={state.selectedDevice ? state.selectedDevice.type : state.selectedDeviceType}
                    devicesConnected={devicesConnected}
                    configurationWarning={state.configurationWarning}
                    onDevicesConnected={(devices) => onDevicesConnected(devices)}
                    onDataError={(message, isWarning) => onDataError(message, isWarning)}
                    selectedDevice={state.selectedDevice}
                    onSelectDevice={(d) => dispatch(SetSelectedDeviceAction.create(d))}
                    onProceed={onDeviceSelection}
                    goTo={goTo}
                    onBack={() => goBack()} />      
            )}
            {currentStep === "skipping-visit" && (
                <SkippingVisit
                    goBack={goBack}
                    outstandingVisits={state.outstandingVisits}
                    selected={state.selectedSessionScheduleItem.filter(i => i.checked).map(s => s.session)}
                    onStartSession={(annotation) => {
                        dispatch(SetSkippingAnnotationAction.create(annotation));
                        onStartSession(annotation);
                    }
                    }
                />
            )}
            {currentStep === "pair-device-link" && (
                <PairDeviceLinkV2 onRetry={() => goTo("device-selection")} />
            )}
            {sessionTypeContext === WizardSessionTypes.VitaloJAK1 && (
                <VitaloJAK1Switch
                    currentStep={currentStep}
                    goTo={goTo} goBack={goBack}
                    state={state}
                    dispatch={dispatch}
                    subject={subject}
                    onError={(message) => setWizardError(message)}
                    onComplete={onWizardClose}
                />
            )}
            {sessionTypeContext === WizardSessionTypes.VitaloJAK2 && (
                <VitaloJAK2Switch currentStep={currentStep} goTo={goTo} goBack={goBack} state={state} subject={subject} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
            )}
            {sessionTypeContext === WizardSessionTypes.BloodGlucose && (
                <BloodGlucoseSwitch currentStep={currentStep} goTo={goTo} goBack={goBack} state={state} subject={subject} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
            )}
            {sessionTypeContext === WizardSessionTypes.P230 && (
                <TestingAssistContextProvider>
                    <P230In2itiveSwitch currentStep={currentStep} goTo={goTo} goBack={goBack} state={state} dispatch={dispatch} subject={subject} wizardError={wizardError} onComplete={onWizardClose} onError={(message) => setWizardError(message)} />
                </TestingAssistContextProvider>
            )}
            {sessionTypeContext === WizardSessionTypes.P230HomeSpirometry && (
                <P230HomeSpirometrySwitch currentStep={currentStep} goTo={goTo} goBack={goBack} state={state} dispatch={dispatch} subject={subject} wizardError={wizardError} onComplete={(redirect) => onWizardClose(redirect)} onError={(message) => setWizardError(message)} />
            )}
            {currentStep === "error" && (
                <CriticalError message={wizardError} onClose={onWizardClose} />
            )}
            {currentStep === "not-handled" && (
                <NotHandled goBack={goBack} />
            )}
        </ErrorBoundary>
    );
}

